export default class LocalStorage {
  constructor(prefix = "") {
    this.prefix = prefix;
  }

  _generateKey() {
    const timestamp = new Date().toISOString();
    return `${this.prefix}${timestamp}`;
  }

  push(value) {
    const serializedValue = JSON.stringify({ ...value, timestamp: new Date() });
    localStorage.setItem(this._generateKey(), serializedValue);
  }

  getAll() {
    const items = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith(this.prefix)) {
        const item = JSON.parse(localStorage.getItem(key));
        items.push(item);
      }
    }
    return items.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }

  getAllWithoutPrefix() {
    const items = [];
    for (let i = 0; i < localStorage.length; i++) {
      const item = JSON.parse(localStorage.getItem(localStorage.key(i)));
      items.push(item);
    }
    return items.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }

  removeItem(key) {
    localStorage.removeItem(this._getKey(key));
  }

  clear() {
    localStorage.clear();
  }
}

